var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.01 20.004L14.591 15.585V17.947H10.019L10.019 13.371L6.972 13.371L9.714 10.628L4 4.99L4.99 4L20 19.004L19.01 19.994V20.004ZM17.638 7.275V5.752L8.648 5.752L10.172 7.275L17.639 7.275H17.638ZM16.268 13.375H17.639L12.305 8.037L11.619 8.723L16.268 13.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpublish);
export default __webpack_public_path__ + "static/media/Unpublish.aee41e959bcc0c853d3442776cc6bdac.svg";
export { ForwardRef as ReactComponent };